module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av73-ef72e6e1b2ea5ffd18202bd822153d24.jpg";